import * as React from 'react';

import * as styles from './ChatList.css';
import { ERequestApiStatus } from '../../types/appState';
import { ScrollableBlock } from '../ScrollableBlock';

// Высота элемента списка чатов
const CHAT_ITEM_HEIGHT = 124;

interface IChatListProps {
  onScrollToEnd: VoidFunction;
  status: ERequestApiStatus;
  children: React.ReactNode;
}

export const ChatList = React.forwardRef<HTMLDivElement, IChatListProps>(({ status, children, onScrollToEnd }, ref) => {
  return (
    <div className={styles['container']} data-name="ChatList">
      <div ref={ref} className={styles['list-container']}>
        {status === ERequestApiStatus.Pending && <div className={styles['overlay']} />}
        <div className={styles['inner-container']}>
          <ScrollableBlock onPageScroll={onScrollToEnd} itemHeight={CHAT_ITEM_HEIGHT}>
            {children}
          </ScrollableBlock>
        </div>
      </div>
    </div>
  );
});

ChatList.displayName = 'ChatList';
